import { render, staticRenderFns } from "./SMRejectedRequests.vue?vue&type=template&id=e722d8da&"
import script from "./SMRejectedRequests.vue?vue&type=script&lang=js&"
export * from "./SMRejectedRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports